angular.module('property-deal')
    .directive('editableCustomSelect', ['editableDirectiveFactory',
        function(editableDirectiveFactory) {
            return editableDirectiveFactory({
                directiveName: 'editableCustomSelect',
                inputTpl: '<select class="form-control"><option value="">brak informacji</option></select>'
            });
    }])
    .controller('PropertyDealFinancingUpdateController', function ($uibModalInstance, data, PropertyDeal) {
        this.$onInit = () => {
            this.item.id = data.id
            this.item.financing = data.financing
        }

        this.save = () => {
            return PropertyDeal.financingUpdate(this.item).then(result => {
                $uibModalInstance.close(result)
            })
        }

        this.cancel = () => {
            $uibModalInstance.dismiss('cancel')
        }
    })

